import { Route, Routes } from 'react-router-dom';
import Hero from './components/Hero';
import LitePage from './pages/LitePage';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Hero />} />
      <Route path="/lite" element={<LitePage />} />
    </Routes>
  );
};

export default Router;
